









































import { Component, Prop, Vue } from "vue-property-decorator";
import { CustomerEditModel } from "@/services/api/nswag/stapiclient_generated";

@Component({
  components: {
  },
})
export default class EditCustomerTextOverwriter extends Vue {
  @Prop() value!: CustomerEditModel;
  @Prop() overwritePropName!: string;
  @Prop() textPropName!: string;
  @Prop() settingsPropName!: string;
  @Prop() isTextarea!: boolean;
  @Prop() labelText!: string;
  @Prop() rows!: string;
  @Prop() placeholder!: string;

  get textareaRows(){
    return this.rows ? this.rows : '4';
  }

  get overwriteProp(){
    return (this.value as any)[this.overwritePropName];
  }

  set overwriteProp(data: boolean){
    let clone: any = { ...this.value, [this.overwritePropName]: data };
    this.$emit("input", clone);
  }

  get settingsTextProp(){
    return (this.value as any)[this.settingsPropName];
  }

  get textProp(){
    return (this.value as any)[this.textPropName];
  }

  set textProp(data: string){
    let clone: any = { ...this.value, [this.textPropName]: data };
    this.$emit("input", clone);
  }
}
